
export interface GetBannerDto
{
    getClientTxnId():string;
    getIdentifier():string;
    getBannerOrder():string;
    getBannerType():string;

    getResponseDescription():string;

}

export class GetBannerDtoImpl implements GetBannerDto
{
    private clientTxnId: string;
    private identifier: string;
    private bannerOrder: string;
    private bannerType: string;
    private responseDescription: string;

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string
    {
        return this.clientTxnId;
    }

    getIdentifier(): string
    {
        return this.identifier;
    }
    setIdentifier(identifier: string)
    {
        this.identifier = identifier;
    }

    setBannerOrder(bannerOrder: string)
    {
        this.bannerOrder = bannerOrder;
    }
    getBannerOrder(): string 
    {
        return this.bannerOrder;
    }   

    getBannerType(): string
    {
        return this.bannerType;
    }
    setBannerType(bannerType: string)
    {
        this.bannerType = bannerType;
    }

    getResponseDescription(): string
    {
        return this.responseDescription;
    }
    setResponseDescription(responseDescription: string)
    {
        this.responseDescription = responseDescription;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getbannerdetails/getbannerdto.ts